import React from 'react';
import { useT } from '../lib/i18n';

// 1. NASZE LINKI Z NAFFY
export const naffyLinks = {
  2: "https://www.naffy.io/headsuponline/bez-reklam-1-dzien-5jt",
  7: "https://www.naffy.io/headsuponline/bez-reklam-1-dzien-5jt-2zff",
  30: "https://www.naffy.io/headsuponline/bez-reklam-1-dzien-5jt-2zff-4cgo",
  365: "https://www.naffy.io/headsuponline/bez-reklam-1-dzien-5jt-2zff-4cgo-oiwT",
  tip: "https://www.naffy.io/headsuponline/postaw-kawe-5ch"
};

// 2. FUNKCJA PRZEKIEROWUJĄCA DO PŁATNOŚCI
export const buyPackage = (packageId) => {
  const uid = localStorage.getItem('playerId') || localStorage.getItem('uid') || "nieznany_gracz";
  
  const baseUrl = naffyLinks[packageId];
  if (baseUrl) {
    const paymentUrl = `${baseUrl}?client_reference_id=${uid}`;
    window.open(paymentUrl, '_blank');
  }
};

// 3. KOMPONENT BANERU
export function AdBanner({ adFreeUntil, onRemove }) {
  const { t } = useT();

  if (adFreeUntil && (adFreeUntil === true || adFreeUntil > Date.now())) return null;

  return (
    <div className="w-full bg-[#12121A] border-2 border-[#FFE800]/30 rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-[#FFE800]/5 pointer-events-none" />
      <div className="text-left relative z-10">
        <h3 className="font-display font-bold text-lg text-[#FFE800]">{t("ad_banner_title") || "Grasz z reklamami"}</h3>
        <p className="text-xs text-[#A0A0B0] mt-1">{t("ad_banner_desc") || "Kup pakiet VIP, aby usunąć reklamy i wspierać serwery."}</p>
      </div>
      <button 
        onClick={onRemove} 
        className="px-5 py-2.5 bg-[#FFE800] text-[#050510] font-bold rounded-xl whitespace-nowrap hover:scale-[1.05] transition-transform relative z-10"
      >
        {t("ad_banner_btn") || "Usuń reklamy"}
      </button>
    </div>
  );
}

// 4. KOMPONENT SKLEPU (Pakiety + Napiwek)
export function SupportPanel({ code, onRoomUpdate, adFreeUntil }) {
  const { t } = useT();

  return (
    <div className="space-y-6">
      {/* Sekcja pakietów VIP */}
      <div>
        <h2 className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#A0A0B0] mb-3">{t("packages_title")}</h2>
        <div className="grid grid-cols-2 gap-3">
          
          <button onClick={() => buyPackage(2)} className="p-3 rounded-2xl border-2 border-white/10 bg-[#12121A] hover:border-[#00FFFF] hover:bg-[#00FFFF]/5 transition-all text-left flex flex-col">
            <span className="font-display font-bold text-white">{t("pkg_48h")}</span>
            <span className="text-xs text-[#00FFFF] mt-1">9 zł</span>
          </button>
          
          <button onClick={() => buyPackage(7)} className="p-3 rounded-2xl border-2 border-white/10 bg-[#12121A] hover:border-[#00FFFF] hover:bg-[#00FFFF]/5 transition-all text-left flex flex-col">
            <span className="font-display font-bold text-white">{t("pkg_7d")}</span>
            <span className="text-xs text-[#00FFFF] mt-1">12 zł</span>
          </button>
          
          <button onClick={() => buyPackage(30)} className="p-3 rounded-2xl border-2 border-white/10 bg-[#12121A] hover:border-[#00FFFF] hover:bg-[#00FFFF]/5 transition-all text-left flex flex-col">
            <span className="font-display font-bold text-white">{t("pkg_30d")}</span>
            <span className="text-xs text-[#00FFFF] mt-1">39 zł</span>
          </button>
          
          <button onClick={() => buyPackage(365)} className="p-3 rounded-2xl border-2 border-white/10 bg-[#12121A] hover:border-[#00FFFF] hover:bg-[#00FFFF]/5 transition-all text-left flex flex-col">
            <span className="font-display font-bold text-white">{t("pkg_1y")}</span>
            <span className="text-xs text-[#00FFFF] mt-1">349 zł</span>
          </button>

        </div>
      </div>

      {/* Sekcja Napiwków */}
      <div>
        <h2 className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#A0A0B0] mb-3">{t("support_title")}</h2>
        <button onClick={() => buyPackage('tip')} className="w-full p-4 rounded-2xl border-2 border-[#FF007F]/40 bg-[#FF007F]/10 hover:border-[#FF007F] hover:bg-[#FF007F]/20 transition-all text-center flex flex-col items-center gap-1 group">
          <span className="font-display font-bold text-[#FF007F] text-lg group-hover:scale-110 transition-transform">{t("buy_coffee")}</span>
          <span className="text-xs text-[#A0A0B0]">{t("coffee_desc")}</span>
        </button>
      </div>
      
    </div>
  );
}